import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DEVICE_CONNECT_CONFIG_DETAIL',
        create: 'DEVICE_CONNECT_CONFIG_CREATE',
        update: 'DEVICE_CONNECT_CONFIG_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'device_uid',
        default: '',
        label: 'device_uid',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this.form.model.device_uid,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "device_uid", $$v);
              }
            }
          });
        }
      }, {
        prop: 'dev_connect_type',
        default: '',
        label: 'dev_connect_type',
        col: {
          span: 16
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "dev_connect_type",
              "button": true
            },
            "model": {
              value: _this.form.model.dev_connect_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "dev_connect_type", $$v);
              }
            }
          });
        }
      }, {
        prop: 'open_cabinet',
        default: '',
        label: 'open_cabinet',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.open_cabinet,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "open_cabinet", $$v);
              }
            }
          });
        }
      }, {
        prop: 'send_info',
        default: '',
        label: 'send_info',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.send_info,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "send_info", $$v);
              }
            }
          });
        }
      }, {
        prop: 'uq_key',
        default: '',
        label: 'uq_key',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.uq_key,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "uq_key", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 洗衣店
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  }
};